// Employee-initiated sign-in link reissue — Employee Portal & App spec §18
// ("Request new access link if needed"). Posts to the self-scoped reissue
// endpoint, which emails a fresh 30-day portal link to the employee's own
// address. Neutral, low-pressure copy (§9.2 / §1.4 #8).

import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api.ts';
import { Button } from '@/components/ui/Button.tsx';
import { Card } from '@/components/ui/Card.tsx';

export function MagicLinkReissueCard() {
  const reissue = useMutation({
    mutationFn: () => api.post<{ ok: true }>('/api/employee/magic-link/reissue'),
  });

  return (
    <Card as="section">
      <h2 className="text-lg font-semibold">Your access</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        Your sign-in link lasts 30 days. If you would like a fresh one — for example to open besideU
        on another device — it can be emailed to you.
      </p>
      <div className="mt-3 flex items-center gap-3">
        <Button type="button" onClick={() => reissue.mutate()} disabled={reissue.isPending}>
          {reissue.isPending ? 'Sending…' : 'Email me a fresh link'}
        </Button>
        {reissue.isSuccess && !reissue.isPending && (
          <span className="text-sm text-muted-foreground" role="status">
            Sent — check your email.
          </span>
        )}
        {reissue.isError && (
          <span className="text-sm text-traffic-red" role="alert">
            Could not send a link just now. Try again.
          </span>
        )}
      </div>
    </Card>
  );
}
